import React from 'react';
import classnames from 'classnames';
import {ErrorMessage} from 'formik';
import _get from 'lodash/get';

export default function TextareaBox({
  style,
  field,
  form: {touched, errors},
  ...props
}) {
  return (
    <>
      <textarea
        {...props}
        {...field}
        className={classnames({
          'form-control': true,
          'is-invalid': _get(touched, field.name) && _get(errors, field.name),
        })}
        style={style}
      />
      <span className="invalid-feedback">
        <ErrorMessage name={field.name} />
      </span>
    </>
  );
}
